export enum DistributionChannelType {
    NotSet = 0,
    SMS = 1,
    Email = 2
}
